import { IconButton, InputAdornment, TextField, Tooltip } from "@mui/material";
import { XIcon } from "@phosphor-icons/react/dist/csr/X";
import { useEffect, useState } from "react";
import { useDebounce } from "../../lib/Hooks";

const ENTER_KEY = 13;

interface ISearchTextBox {
  value: string;
  className?: string;
  onChange: (searchTerm: string) => void;
  placeholder?: string;
}

const SearchTextBox = ({ value, className, onChange, placeholder }: ISearchTextBox) => {
  const [searchTerm, setSearchTerm] = useState(value);
  const [prevValue, setPrevValue] = useState(value);
  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  if (prevValue !== value) {
    setPrevValue(value);
    setSearchTerm(value);
  }

  useEffect(() => {
    onChange(debouncedSearchTerm);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchTerm]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setSearchTerm(event.target.value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.keyCode === ENTER_KEY) {
      onChange(searchTerm);
      e.preventDefault();
    }
  };

  return (
    <TextField
      fullWidth
      id="search"
      variant="outlined"
      size="small"
      className={className}
      value={searchTerm}
      placeholder={placeholder}
      onKeyDown={handleKeyDown}
      onChange={handleChange}
      test-label="search-text-box"
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <Tooltip id="tooltip" placement="right" arrow title="clear">
                <IconButton onClick={() => setSearchTerm("")}>
                  <XIcon />
                </IconButton>
              </Tooltip>
            </InputAdornment>
          ),
          style: {
            paddingRight: 0,
            height: "32px",
            borderRadius: 8,
          },
        },
      }}
    />
  );
};

export { SearchTextBox };
